import { Component, Input } from '@angular/core';
import { Acte } from 'apps/idl/src/model/Acte';
import { IActe } from 'apps/idl/src/model/IActe';
import { Traitement } from 'apps/idl/src/model/Traitement';

@Component({
  selector: 'di-panneau-acte-prise-en-charge',
  templateUrl: './panneau-acte-prise-en-charge.component.html',
  styleUrls: ['./panneau-acte-prise-en-charge.component.scss'],
})
export class PanneauActePriseEnChargeComponent  {

  @Input() acte?: IActe;
  @Input() index?: number;
	@Input() ordonnance : Traitement;
  @Input() onSave: (acte: Acte) => void;
  @Input() onCancel: () => void;
  @Input() domicileOnly: boolean;

  constructor(
  ) { }
}